import { render, staticRenderFns } from "./ComposerMockPage.vue?vue&type=template&id=575ec51b&scoped=true"
import script from "./ComposerMockPage.vue?vue&type=script&lang=js"
export * from "./ComposerMockPage.vue?vue&type=script&lang=js"
import style0 from "./ComposerMockPage.vue?vue&type=style&index=0&id=575ec51b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ec51b",
  null
  
)

export default component.exports